<template>
  <!-- 日本語のときの表示DOM -->
  <div class="p-userauthentication__comment-wrap" v-if="locale === 'ja'">
    <p v-if="!isSmartPhone" class="p-userauthentication__comment">
      {{ t('AuthenticateUserPage.haveAccount') }}
      <a class="-login" :href="fluxLoginUrl">{{ t('AuthenticateUserPage.loginLabel') }}</a>
    </p>
    <p class="p-userauthentication__comment -gray" v-if="fluxTermsUrl && fluxPrivacyPolicyUrl">
      ユーザー登録を行うことで、
      <a class="-term" :href="fluxTermsUrl" target="_blank" rel="noopener noreferrer">
        {{ t('AuthenticateUserPage.termsOfService') }}
      </a>
      、
      <a
        class="p-userauthentication__note-link"
        :href="fluxPrivacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ t('AuthenticateUserPage.privacyPolicy') }}
      </a>
      に同意するものとします。
    </p>
  </div>
  <!-- 英語のときの表示DOM -->
  <div class="p-userauthentication__comment-wrap" v-if="locale === 'en'">
    <p v-if="!isSmartPhone" class="p-userauthentication__comment">
      {{ t('AuthenticateUserPage.haveAccount') }}
      <a class="-login" :href="fluxLoginUrl">{{ t('AuthenticateUserPage.loginLabel') }}</a>
    </p>
    <p class="p-userauthentication__comment -gray" v-if="fluxTermsUrl && fluxPrivacyPolicyUrl">
      By your registration, we assume that you have accepted the
      <a class="-term" :href="fluxTermsUrl" target="_blank" rel="noopener noreferrer">
        {{ t('AuthenticateUserPage.termsOfService') }}
      </a>
      and
      <a
        class="p-userauthentication__note-link"
        :href="fluxPrivacyPolicyUrl"
        target="_blank"
        rel="noopener noreferrer"
        >{{ t('AuthenticateUserPage.privacyPolicy') }}</a
      >
    </p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import AppInfo from '@/util/AppInfo'

/**
 * 言語ごとに表示する内容を切り替えるために作成
 */
export default defineComponent({
  name: 'AuthUserComment',
  setup() {
    const { locale } = useI18n()
    const isSmartPhone = computed(() => {
      return AppInfo.isSmartPhone
    })
    const fluxLoginUrl = computed(() => {
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/fl/index.html#/login`
    })
    const fluxTermsUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_TERMS_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_TERMS_PAGE_PATH}`
    })
    const fluxPrivacyPolicyUrl = computed(() => {
      if (!process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL) return ''
      return locale.value === 'ja'
        ? process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL + process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH
        : `${process.env.VUE_APP_FLUX_PROMO_PAGE_BASE_URL}/en${process.env.VUE_APP_FLUX_PRIVACY_PAGE_PATH}`
    })
    return {
      fluxLoginUrl,
      fluxTermsUrl,
      fluxPrivacyPolicyUrl,
      isSmartPhone,
      ...useI18n(),
    }
  },
})
</script>

<style scoped lang="scss"></style>
